// eslint - disable - next - line;
export enum QueryIDsBusinessLeaderDashBoard {
  "targetVsActualPRId" = "5731076903272448",
  "lastMonthTargetVsActualId" = "5726177821982720",
  "last7DaysSince2DaysAgoId" = "5738294193160192",
  "brandPerformanceId" = "5657818854064128",
  "topKeyWordId" = "5732929242136576",
  "mtdQftdBudgetControlId" = "5683371963318272",
  "conversionLoadingPercLast14DaysId" = "5694955355897856",
}
